export default __webpack_public_path__ + "static/media/check.2c9fdef3.png";